import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const TopMitras = ({ mitras, formatCurrency }) => {
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Top Performing Mitras</h5>
                <a href="#" className="btn btn-sm btn-outline-primary">View All</a>
            </div>
            <div className="card-body">
                <ul className="list-group list-group-flush">
                    {mitras.map((mitra, index) => (
                        <li key={mitra.id} className="list-group-item px-0 py-3 d-flex justify-content-between align-items-center border-bottom">
                            <div className="d-flex align-items-center">
                                <div className="me-3 position-relative">
                                    <div 
                                        style={{ 
                                            width: '50px', 
                                            height: '50px',
                                            borderRadius: '50%',
                                            backgroundImage: `url(${mitra.foto_profil || 'https://via.placeholder.com/50?text=' + mitra.nama_lengkap?.charAt(0)})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center'
                                        }}
                                    ></div>
                                    {index < 3 && (
                                        <div 
                                            className="position-absolute bottom-0 end-0 bg-warning text-white rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: '22px', height: '22px', fontSize: '12px', fontWeight: 'bold' }}
                                        >
                                            {index + 1}
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <h6 className="mb-0">{mitra.nama_lengkap}</h6>
                                    <small className="text-muted">
                                        <Icon icon="mdi:calendar-check" className="me-1" />
                                        {mitra.completedBookings} bookings
                                    </small>
                                </div>
                            </div>
                            <div className="text-end">
                                <div className="fw-bold text-success">{formatCurrency(mitra.revenue)}</div>
                                <small className="text-muted">earned</small>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TopMitras;